<template>
  <div id="input_business">
    <ul>
      <li class="input_text">
        <div>
          <span>{{label.businessName}}</span>
          <span class="important small_text">必須</span>
        </div>
        <input type="text" v-model.trim="form.businessName" maxlength="32"  placeholder="施主名(物件名)"/>
        <div v-if="errors.businessName" class="error_text">{{errors.businessName}}</div>
      </li>
      <li class="input_text">
        <div>
          <span>{{label.building}}</span>
          <span class="important small_text">必須</span>
        </div>
        <input type="text" v-model.trim="form.building" maxlength="32"  placeholder="納品先名"/>
        <div v-if="errors.building" class="error_text">{{errors.building}}</div>
      </li>
      <li class="input_text">
        <div>
          <span>{{label.postcd}}</span>
          <span class="small_p">（半角数値、ハイフン不要）</span>
          <span class="important small_text">必須</span>
        </div>
        <input type="text" disabled="disabled" v-model.trim="form.postcd" @keypress="validateNumber" @input="form.postcd=inputRestNumber($event)" oninput="if(value.length>7)value=value.slice(0,7)" placeholder="0001111"/>
        <div v-if="errors.postcd" class="error_text">{{errors.postcd}}</div>
      </li>
      <li class="input_text2">
        <div>
          <span>{{label.state}}</span>
          <span class="important small_text">必須</span>
        </div>
        <div class="input_field">
          <input type="text" disabled="disabled" v-model.trim="form.state" placeholder="都道府県">
          <span class="space"></span>
          <input type="text" disabled="disabled" v-model.trim="form.city" placeholder="市区町村">
        </div>
        <div v-if="errors.state" class="error_text">{{errors.state}}</div>
      </li>
      <li class="input_text">
        <div>
          <span>{{label.street}}</span>
          <span class="important small_text">必須</span>
        </div>
        <input type="text" v-model.trim="form.street" placeholder="町名" maxlength="32">
        <div v-if="errors.street" class="error_text">{{errors.street}}</div>
      </li>
      <li class="input_text2">
        <div>
          <span>{{label.userName}}</span>
          <span class="important small_text">必須</span>
        </div>
        <div class="input_field">
          <input type="text" v-model.trim="form.userLastName" maxlength="32" placeholder="家具"/>
          <span class="space"></span>
          <input type="text" v-model.trim="form.userFirstName" maxlength="32" placeholder="太郎"/>
        </div>
        <div v-if="errors.userName" class="error_text">{{errors.userName}}</div>
      </li>
      <li class="input_text2">
        <div>
          <span>{{label.userNameKana}}</span>
          <span class="important small_text">必須</span>
        </div>
        <div class="input_field">
          <input type="text" v-model.trim="form.userLastNameKana" maxlength="32" placeholder="カグ"/>
          <span class="space"></span>
          <input type="text" v-model.trim="form.userFirstNameKana" maxlength="32" placeholder="タロウ"/>
        </div>
        <div v-if="errors.userNameKana" class="error_text">{{errors.userNameKana}}</div>
      </li>
      <li class="input_text">
        <div>
          <span>{{label.tel}}</span>
          <span class="small_p">（半角数値、ハイフン不要）</span>
          <span class="important small_text">必須</span>
        </div>
        <input type="text" v-model.trim="form.tel" @keypress="validateNumber" @input="form.tel=inputRestNumber($event)" oninput="if(value.length>11)value=value.slice(0,11)" placeholder="0123456789" maxlength="11"/>
        <div v-if="errors.tel" class="error_text">{{errors.tel}}</div>
      </li>
    </ul>
    <!-- ローディングモーダル -->
    <!-- <dd-loading-modal ref="loadingModalRef" /> -->
  </div>
</template>
<script>
import * as Check from '../../../utils/Check'
import * as FormUtil from '../../../utils/FormUtil'
// import LoadingModal from '../../components/common/LoadingModal'

export default {
  name: 'OrderInput',
  components: {
    // 'dd-loading-modal': LoadingModal
  },
  props: {
    label: Object,
    form: Object
  },
  data () {
    return {
      errors: {}
    }
  },
  methods: {
    confirm: function () {
      // 入力エラーのクリア
      // this.$refs.loadingModalRef.showModal(true)
      this.errors = {}

      // 入力チェック
      this.validateRequire()
      if (Object.keys(this.errors).length !== 0) {
        return false
      }
      this.validateFormat()
      if (Object.keys(this.errors).length !== 0) {
        return false
      }
      return true
      // this.$refs.loadingModalRef.showModal(false)
    },
    validateRequire: function () {
      // 必須チェック
      if (!this.form.postcd) this.errors['postcd'] = this.label.postcd + 'は必須項目です。'
      if (!this.form.building) this.errors['building'] = this.label.building + 'は必須項目です。'
      if (!this.form.state || !this.form.city) this.errors['state'] = this.label.state + 'は必須項目です。'
      if (!this.form.street) this.errors['street'] = this.label.street + 'は必須項目です。'
      if (!this.form.tel) this.errors['tel'] = this.label.tel + 'は必須項目です。'
      if (!this.form.businessName) this.errors['businessName'] = this.label.businessName + 'は必須項目です。'
      if (!this.form.userLastName || !this.form.userFirstName) this.errors['userName'] = this.label.userName + 'は必須項目です。'
      if (!this.form.userLastNameKana || !this.form.userFirstNameKana) this.errors['userNameKana'] = this.label.userNameKana + 'は必須項目です。'
    },
    validateFormat: function () {
      if (!Check.isPostCd(this.form.postcd)) this.errors['postcd'] = this.label.postcd + 'は半角数値で入力してください。'
      if (!Check.isTel(this.form.tel)) this.errors['tel'] = this.label.tel + 'は半角数値かつ、10～11文字で入力してください。'
      if (!Check.isKana(this.form.userLastNameKana) || !Check.isKana(this.form.userFirstNameKana)) this.errors['userNameKana'] = this.label.userNameKana + 'はカタカナで入力してください。'
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      if (str.length <= 0) {
        return ''
      }
      return str
    }
  },
  computed: {
    isConfirm: function () {
      if (this.form.postcd && this.form.state && this.form.city && this.form.street) {
        return true
      }
      return false
    }
  },
  watch: {
  },
  mounted () {
  },
  created () {
  }
}
</script>
<style src="../../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/order/DcBusinessInput.vue